export const flDataTypes = {
  SAVE_DATA: "SAVE_DATA",
};
